import { render, staticRenderFns } from "./planosBimestrais.vue?vue&type=template&id=592dee9c"
import script from "./planosBimestrais.vue?vue&type=script&lang=js"
export * from "./planosBimestrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports